import * as yup from 'yup';
import { toastError } from '../../../toasts';
import { durationPresetKeys, loyaltyTypesKeys, rewardTypesKeys } from '../constants';

const numericFields = [
  'cashbackFixedValue',
  'cashbackPercentage',
  'cashbackGoalValue',
  'goalQuantity',
  'goalValue',
  'rewardValue',
  'rewardPercentage',
  'validityDays',
  'durationCustomDays',
];

export async function validateLoyaltyForm(rawForm) {
  try {
    const form = { ...rawForm };

    numericFields.forEach((field) => {
      if (form[field] === '' || form[field] === undefined) {
        form[field] = null;
      }
    });

    const schema = yup.object({
      type: yup.string().required('Tipo de fidelidade é obrigatório'),
      name: yup.string().required('Nome da campanha é obrigatório'),
      description: yup.string().required('Descrição é obrigatória'),

      cashbackModo:
        form.type === loyaltyTypesKeys.cashback
          ? yup.string().required('Selecione como o cashback é calculado')
          : yup.string().nullable(),

      cashbackFixedValue:
        form.type === loyaltyTypesKeys.cashback &&
        (form.cashbackModo === 'por_pedido' || form.cashbackModo === 'meta_valor')
          ? yup.number().typeError('Valor é obrigatório').required('Valor é obrigatório')
          : yup.number().nullable(),

      cashbackPercentage:
        form.type === loyaltyTypesKeys.cashback && form.cashbackModo === 'percentual'
          ? yup.number().typeError('Percentual é obrigatório').required('Percentual é obrigatório')
          : yup.number().nullable(),

      cashbackGoalValue:
        form.type === loyaltyTypesKeys.cashback && form.cashbackModo === 'meta_valor'
          ? yup
              .number()
              .typeError('Valor necessário é obrigatório')
              .required('Valor necessário é obrigatório')
          : yup.number().nullable(),

      goalQuantity:
        form.type === loyaltyTypesKeys.pedidos
          ? yup.number().typeError('Quantidade é obrigatória').required('Quantidade é obrigatória')
          : yup.number().nullable(),

      goalValue:
        form.type === loyaltyTypesKeys.valor_acumulado
          ? yup
              .number()
              .typeError('Valor necessário é obrigatório')
              .required('Valor necessário é obrigatório')
          : yup.number().nullable(),

      rewardType:
        form.type !== loyaltyTypesKeys.cashback
          ? yup.string().required('Selecione a recompensa do cliente')
          : yup.string().nullable(),

      rewardValue:
        form.type !== loyaltyTypesKeys.cashback &&
        (form.rewardType === rewardTypesKeys.desconto_fixo ||
          form.rewardType === rewardTypesKeys.cashback)
          ? yup
              .number()
              .typeError('Valor da recompensa é obrigatório')
              .required('Valor da recompensa é obrigatório')
          : yup.number().nullable(),

      rewardPercentage:
        form.type !== loyaltyTypesKeys.cashback &&
        form.rewardType === rewardTypesKeys.desconto_percentual
          ? yup
              .number()
              .typeError('Percentual da recompensa é obrigatório')
              .required('Percentual da recompensa é obrigatório')
          : yup.number().nullable(),

      durationCustomDays:
        form.durationPreset === durationPresetKeys.personalizado
          ? yup
              .number()
              .typeError('Informe a quantidade de dias')
              .positive('Informe a quantidade de dias')
              .required('Informe a quantidade de dias')
          : yup.number().nullable(),
    });

    return await schema.validate(form);
  } catch (error) {
    console.log(error);

    if (error instanceof yup.ValidationError) {
      toastError(error.message);
    }

    return null;
  }
}
